export enum NotificationEvents {
  GeneralNotification = 0,
  PageDataUpdated = 1,
  InstallationPackageBuilt = 2,
  WizardStep_Dashboard_Updated = 3,
  WizardStep_Installation_Updated = 4,
  WizardStep_TendersMapping_Updated = 5,
  WizardStep_Distribution_Updated = 6,
  PayDay_POS_SyncFinished = 7,
  CalculationLambda_FinishedSuccess = 8,
  CalculationLambda_FinishedFailure = 9,
  WorkflowExecution_Finished = 10,
  ServiceStatusMessage_Updated = 11,
  GSNotification = 13,
  BulkLocationCreated = 14,
  TlmTimeDataUpdated = 15,
  // Stream S8, US-8.25 - solver progress and schedule changes pushed to the Builder.
  // Must match ScheduleChangeBroadcaster in GSTLMAPI and the SignalR hub's enum.
  TlmScheduleUpdated = 16,
}
